import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  a4paper: {
    width: 798,
    height: 1126,
    backgroundColor: custom.grey[5],
    padding: 80,
  },
  documentFirstSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    textAlign: 'right',
  },
  documentSectionTitle: {
    marginBottom: 5,
    paddingTop: 30,
    fontFamily: 'Merriweather',
    fontSize: 14,
    fontWeight: 'bold',
  },
  documentThirdSectionTitle: {
    marginBottom: 20,
    paddingTop: 50,
    fontFamily: 'Merriweather',
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  documentThirdSectionText: {
    marginBottom: 30,
    height: 160,
    fontSize: 15,
    lineHeight: 2,
    textAlign: 'justify',
  },
  documentInfo: {
    fontSize: 13,
  },
  signature: {
    marginBottom: 30,
    display: 'flex',
    justifyContent: 'flex-end',
    textAlign: 'right',
  },
  waterMark: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textTransform: 'uppercase',
    fontSize: 130,
    fontWeight: 'bold',
    lineHeight: 1,
    opacity: 0.1,
  },
  waterMarkText: {
    transform: 'rotate(45deg)',
  },
}));
